import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ConsultModal = ({ show, handleClose }) => {
  const modalStyles = {
    leftSide: {
      backgroundImage: "url('https://images.pexels.com/photos/6863334/pexels-photo-6863334.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2')",
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      minHeight: '100%',
      position: 'relative',
      borderRadius: '10px 0 0 10px',
      overflow: 'hidden'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      zIndex: 1
    },
    textContent: {
      padding: '20px',
      zIndex: 2,
      position: 'relative'
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Body className="p-0">
        <div className="row g-0">
          {/* Left Side - Image and Text */}
          <div
            className="col-md-5 d-none d-md-flex flex-column justify-content-center text-white p-4"
            style={modalStyles.leftSide}
          >
            <div style={modalStyles.overlay}></div>
            <div style={modalStyles.textContent}>
              <h4>Need Help?</h4>
              <h2>We're Here to Assist You</h2>
              <p>Something isn’t clear? Contact us, and we’ll be happy to answer all of your questions.</p>
            </div>
          </div>
          {/* Right Side - Form */}
          <div className="col-md-7 p-4 bg-white">
            <Modal.Header closeButton></Modal.Header>
            <h4 className="mb-3">Request a Callback
                
            </h4>
            
            <form action="https://formspree.io/f/xeolygkr" method="POST">
              <div className="mb-3">
                <input type="text" name="name" className="form-control" placeholder="Name" required />
              </div>
              <div className="mb-3">
                <input type="email" name="email" className="form-control" placeholder="Email" required />
              </div>
              <div className="mb-3">
                <input type="tel" name="phone" className="form-control" placeholder="Contact No." required />
              </div>
              <div className="mb-3">
                <textarea name="message" className="form-control" rows="4" placeholder="Your Message" required></textarea>
              </div>
              <Button type="submit" variant="dark" className="w-100">
                Request a Callback
              </Button>
              
            </form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConsultModal;